import { createApiSlice } from "@common/common-slice/commonSlice";


const apiConfig = [
];

const customReducers = {
  initialState: {
    TemplateTypeData: [],
    assessmentTypeSelectedData: null,
  },

  reducers: {
    assessmentTypeSelect: (state, action) => {
      state.assessmentTypeSelectedData =
        action?.payload;
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "TemplateType",
  apiConfig,
  customReducers,
);

const TemplateTypeSlice = slice;

export default TemplateTypeSlice.reducer;

export const {
  assessmentTypeSelect,
} = actions;
